// /frontend/src/components/Auth/AuthText.js
import React from "react";
import "./AuthText.scss";

function AuthText() {
	return (
		<div className="auth-text-container">
			<div className="auth-text">
				<span className="sentence sentence1">
					Empowering Insight through<br />Discussion Knowledge.
				</span>
				<span className="sentence sentence2">
					Your Hub for<br />Collaborative Expertise.
				</span>
				<span className="sentence sentence3">
					Fostering Dialogue<br />with Trusted Resources.
				</span>
				<span className="sentence sentence4">
					Where Expert Discussion<br />Drives Knowledge.
				</span>
			</div>
		</div>
	);
}

export default AuthText;
